module.exports = __webpack_public_path__ + "img/linkedin-original.35aa922c.svg";